<template>
  <div>
    <div class="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
      <!-- new member request card -->
      <div class="bg-white p-4 rounded-xl">
        <div class="bg-blue w-min h-min rounded-lg p-2">
          <UserPlusIcon class="w-8 h-8 text-white"/>
        </div>
        <div @click="handleMemberReqClick" class="group cursor-pointer">
          <h1 class="font-bold text-4xl text-blue mt-6 mb-2">
            {{ summaries.new_member_request }}
          </h1>
          <p
              class="
              text-gray text-lg
              group-hover:text-blue group-hover:underline
            "
          >
            New Members Request
          </p>
        </div>
      </div>
      <!-- request profile update card -->
      <div class="bg-white p-4 rounded-xl">
        <div class="bg-blue w-min h-min rounded-lg p-2">
          <UserCircleIcon class="w-8 h-8 text-white"/>
        </div>
        <div @click="handleReqUpdateClick" class="group cursor-pointer">
          <h1 class="font-bold text-4xl text-blue mt-6 mb-2">
            {{ summaries.member_request_update }}
          </h1>
          <p
              class="
              text-gray text-lg
              group-hover:text-blue group-hover:underline
            "
          >
            Request Profile Update
          </p>
        </div>
      </div>
      <!-- member subscription card -->
      <div
          v-for="summary in summaries.total_member_subscription"
          :key="summary.subscription.id"
          class="bg-white p-4 rounded-xl"
      >
        <div class="bg-blue w-min h-min rounded-lg p-2">
          <UserIcon class="w-8 h-8 text-white"/>
        </div>
        <div>
          <h1 class="font-bold text-4xl text-blue mt-6 mb-2">
            {{ summary.total_user }}
          </h1>
          <p @click="handlePushToMemberWithSub(summary.subscription.id)"
             class="
  group cursor-pointer
    text-gray text-lg
    group-hover:text-blue group-hover:underline
    hover:underline
  "
          >
            {{ summary.subscription.name }}
          </p>
          <p @click="handlePushToMemberWithSub(summary.subscription.id, 1)"
             class="
  group cursor-pointer
    text-gray text-lg
    group-hover:text-blue group-hover:underline
    hover:underline
  "
          >
            Total Paid: {{ summary.total_paid }}
          </p>
          <p @click="handlePushToMemberWithSub(summary.subscription.id, 0)"
             class="
  group cursor-pointer
    text-gray text-lg
    group-hover:text-blue group-hover:underline
    hover:underline
  "
          >
            Total Un-Paid: {{ summary.total_unpaid }}
          </p>
        </div>
      </div>
      <!-- active member -->
      <div class="bg-white p-4 rounded-xl">
        <div class="bg-blue w-min h-min rounded-lg p-2">
          <CheckCircleIcon class="w-8 h-8 text-white"/>
        </div>
        <div @click="PushToMemberStatus(2)" class="group cursor-pointer">
          <h1 class="font-bold text-4xl text-blue mt-6 mb-2">
            {{ summaries.active_member }}
          </h1>
          <p class="text-gray text-lg group-hover:text-blue group-hover:underline">Active Members</p>
        </div>
      </div>
      <!-- inactive memeber -->
      <div class="bg-white p-4 rounded-xl">
        <div class="bg-blue w-min h-min rounded-lg p-2">
          <XCircleIcon class="w-8 h-8 text-white"/>
        </div>
        <div @click="PushToMemberStatus(0)" class="group cursor-pointer">
          <h1 class="font-bold text-4xl text-blue mt-6 mb-2">
            {{ summaries.inactive_member }}
          </h1>
          <p
              class="
              text-gray text-lg
              group-hover:text-blue group-hover:underline
            "
          >
            Inactive Members
          </p>
        </div>
      </div>
      <!-- total member card -->
      <div class="bg-white p-4 rounded-xl">
        <div class="bg-blue w-min h-min rounded-lg p-2">
          <UserGroupIcon class="w-8 h-8 text-white"/>
        </div>
        <div @click="handleTotalMemberClick" class="group cursor-pointer">
          <h1 class="font-bold text-4xl text-blue mt-6 mb-2">
            {{ summaries.total_member }}
          </h1>
          <p
              class="
              text-gray text-lg
              group-hover:text-blue group-hover:underline
            "
          >
            Total Members
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  UserPlusIcon,
  UserCircleIcon,
  UserIcon,
  UserGroupIcon,
  XCircleIcon,
  CheckCircleIcon,
} from "@heroicons/vue/24/solid";
import userService from "../Services/user.service";

export default {
  name: "Dashboard",
  components: {
    UserPlusIcon,
    UserCircleIcon,
    UserIcon,
    UserGroupIcon,
    XCircleIcon,
    CheckCircleIcon,
  },
  data() {
    return {
      summaries: [],
    };
  },
  methods: {
    getDashBoardSummray() {
      userService.getDashboard().then((response) => {
        this.summaries = response.data;
      });
    },
    handleMemberReqClick() {
      this.$router.push("/request_member");
    },
    handleReqUpdateClick() {
      this.$router.push("/request_update");
    },
    handleTotalMemberClick() {
      this.$router.push("/manage_member");
    },
    handlePushToMemberWithSub(subscription_id, is_paid) {
      this.$router.push({
        name: "ManageMember",
        query: {
          subscription_id: subscription_id,
          is_paid: is_paid,
        },
      });
    },
    PushToMemberStatus(status_id) {
      this.$router.push({
        name: "ManageMember",
        query: {
          status_id: status_id,
        },
      });
    }
  },
  created() {
    this.$Progress.start();
    this.getDashBoardSummray();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
</style>